























































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Task from "./groundlights_task.vue";

@Component({
  components: {
    Task
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  taskModalVisible: boolean = false;

  dispatchType: string = "equipment/sub";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "片场名", dataIndex: "name" },
    { title: "运行状态", scopedSlots: { customRender: "equipment_status" } },
    { title: "打开状态", scopedSlots: { customRender: "status" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  showTaskModal(id: number) {
    this.editId = id;
    this.taskModalVisible = true;
  }

  hideTaskModal() {
    this.taskModalVisible = false;
  }

  mounted() {
    // console.log(this.grounds);
    this.loadData(
      {
        stadium_id: this.stadiumId,
        type: 2
      },
      false
    );
  }

  toggleSubEquip(etype: number, subid: number, ctrl_type: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: `确定要${ctrl_type ? "打开" : "关闭"}该设备吗？`,
      onOk: async () => {
        let action = "stadium/toggleSubEquip";

        if (etype === 5) {
          action = "stadium/toggleMainEquip";
        }

        const res = await this.$store.dispatch(action, {
          stadium_id: this.stadiumId,
          sub_id: subid,
          ctrl_type
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
          this.loadData(
            {
              stadium_id: this.stadiumId,
              type: 2
            },
            false
          );
        } else {
          this.$message.error("操作失败");
        }
      }
    });
  }
}
